<template>
  <div>
    <div class="feature-top">
      <product-feature-summary
        :imagePath="'/static/products/eco-chime/feature/summary.jpg'"
        :altText="`電池レスチャイムのエコチャイム`"
        :headerText="
          `押して発電する革新的な電池レスチャイム！高い防水性・耐久性を実現。`
        "
        :detailText="
          `電池を使わないエコチャイムは、従来の飲食店やご家庭、工場での使用はもちろん、
          手の届きにくい場所や、取り外しにくい場所など幅広い場所で使用できる新しいチャイムです。
          さらには防水性能も向上して丸洗いできるので、常に清潔な衛生状態で様々な場所での利用に適しています。`
        "
        :color="'blue'"
      />

      <img
        class="feature-title-image"
        v-lazy="'/static/products/eco-chime/feature/feature_title.jpg'"
      />

      <div class="feature-contents">
        <div class="feature-content">
          <content-header
            headingTitle="1"
            headingTitleRadius="0"
            title="電池レス"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <img v-lazy="'/static/products/eco-chime/feature/feature_01.png'" />
          <p>
            電池のランニングコストがかからず交換の手間や電池によるトラブルがありません。
          </p>
        </div>
        <div class="feature-content">
          <content-header
            headingTitle="2"
            headingTitleRadius="0"
            title="高い防水性と耐久性"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <img v-lazy="'/static/products/eco-chime/feature/feature_02.png'" />
          <p>
            防塵・防水対応の送信機だから、工場や屋外、浴室でも使用可能。汚れたら水洗いできます。
          </p>
          <p>
            さらに、20万回のプッシュテストもクリアする高い耐久性があります。
          </p>
        </div>
        <div class="feature-content">
          <content-header
            headingTitle="3"
            headingTitleRadius="0"
            title="安心の 3 年間保証"
            withBorder="true"
            fontColor="black"
            borderColor="blue"
          />
          <img v-lazy="'/static/products/eco-chime/feature/feature_03.png'" />
          <p>お客様に安心してご利用いただける安心の3年保証。</p>
          <p>業界の常識を覆した自信作だからできる長期保証です。</p>
        </div>
      </div>
    </div>

    <div class="feature-section">
      <div class="circle-parent">
        <div class="circle-heading blue">
          <h2 class="circle-heading-title">実証試験</h2>
        </div>
      </div>

      <div class="verification-test">
        <div class="header">
          <h3>
            通信処理速度・防水・耐久性試験動画
          </h3>
        </div>
        <div class="body">
          <div class="test-scene">
            <h4>通信処理速度は、驚きの0,001秒！</h4>
            <a href="https://youtu.be/Ksv-0k6vcVI" target="_blank">
              <img
                v-lazy="
                  '/static/products/eco-chime/feature/vertification_test_01.png'
                "
              />
            </a>
            <p>
              従来のコードレスチャイムは、ほぼ同時にコールボタンが押されると受信処理ができませんでした。エコチャイムはほぼ同時に押された呼び出しを、もらさず受信表示することができます。
            </p>
          </div>
          <div class="test-scene">
            <h4>強化された防水性能</h4>
            <a href="https://youtu.be/YSMqL8_tFLI" target="_blank">
              <img
                v-lazy="
                  '/static/products/eco-chime/feature/vertification_test_02.png'
                "
              />
            </a>
            <p>
              飲み物をこぼして汚れた時など、水洗いもOK！お風呂場で使用中に落下しても心配ありません。
            </p>
            <p>
              ※ただし水中での使用はご遠慮ください。
            </p>
            <p>
              <a
                href="https://echo5555.co.jp/eco-chime/products/pdf/ip_bousui.pdf"
                target="_blank"
              >
                IP（防塵・防水）性能規格表はこちら（PDF）
              </a>
            </p>
          </div>
          <div class="test-scene">
            <h4>強度な耐久性</h4>
            <a href="https://youtu.be/hRUcNGB8hIM" target="_blank">
              <img
                v-lazy="
                  '/static/products/eco-chime/feature/vertification_test_03.png'
                "
              />
            </a>
            <p>
              従来のコードレスチャイムは、約1万回の利用で電池の交換が必要です。
            </p>
            <p>
              しかし、エコチャイムは、20万回のプッシュテストをクリアした高い耐久性があります。
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="feature-section">
      <div class="circle-parent">
        <div class="circle-heading blue">
          <h2 class="circle-heading-title">利用シーン</h2>
        </div>
      </div>

      <div class="use-scene">
        <div class="header">
          <h3>
            電池レスで使用できるので、これまでの使用方法はもちろん、<br />
            今後もさまざまな場所での使用が考えられます。
          </h3>
        </div>
        <div class="body">
          <div class="use-scene-block-headers">
            <div class="use-scene-block-header" style="width: 30%;">
              飲食店で
            </div>
            <div class="use-scene-block-header" style="width: 65%;">
              ご家庭で
            </div>
          </div>
          <div class="use-scene-blocks">
            <div class="use-scene-block">
              <img v-lazy="'/static/products/eco-chime/feature/scene_01.png'" />
              <h4>これまでにない快適なチャイム</h4>
              <p>
                煩わしい電池関係の問題を解決した上、より丈夫になったエコチャイム。環境に配慮したチャイムはお店のCSRの取組みにも最適です。
              </p>
              <link-button
                v-bind:link="`/choice/industry/1`"
                v-bind:title="`こちらのシーンにマッチする商品を見る`"
              />
            </div>
            <div class="use-scene-block">
              <img v-lazy="'/static/products/eco-chime/feature/scene_02.png'" />
              <h4>お風呂場からの呼び出しに。</h4>
              <p>
                防水加工もばっちりなエコチャイム。<br />
                浴槽のそばに取り付けてみては？
              </p>
            </div>
            <div class="use-scene-block">
              <img v-lazy="'/static/products/eco-chime/feature/scene_03.png'" />
              <h4>ベッドのそばにもこれひとつ。</h4>
              <p>
                ご家庭での介護では、つきっきりでそばにいることは困難です。何かあったとき、電池切れがないエコチャイムはいつでも安心です。
              </p>
              <link-button
                v-bind:link="`/choice/industry/5`"
                v-bind:title="`こちらのシーンにマッチする商品を見る`"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="feature-section">
      <div class="circle-parent">
        <div class="circle-heading blue">
          <h2 class="circle-heading-title">主な機能</h2>
        </div>
      </div>

      <div class="main-function blue">
        <div class="body">
          <div class="product-block">
            <div class="product-block-header">
              <h3 class="product-genre">送信機</h3>
              <div class="product-detail">
                <p class="product-name">eco-chime 送信機</p>
                <p>電磁誘導式自己発電部内蔵型の</p>
                <p>コードレスチャイム。</p>
              </div>
            </div>
            <div style="position: relative;">
              <img
                class="product-image"
                v-lazy="'/static/products/eco-chime/feature/function_01.png'"
              />
              <div class="product-model">丸型</div>
            </div>
            <div class="function">
              <div class="function-title">
                キュートで使い勝手が良いチャイム
              </div>
              <div class="function-detail">
                わずかな力で360度どこからでも押せる丸型。頂点部だけでなく縁に近い部分でも押すことができ、ひじや肩などでの使用も可能。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                カラーバリエーション
              </div>
              <div class="function-detail">
                ブラック (EC-305) (EC-312)、大理石調 (EC-313)、<br />
                ライトウッド(EC-314)、ウッド (EC-315)
              </div>
            </div>
            <div
              class="function"
              style="border-bottom: 1px solid rgb(199, 199, 199);"
            >
              <div class="function-title">
                ベルのマークをお貼りできます
              </div>
              <div class="function-detail">
                <img
                  v-lazy="'/static/products/eco-chime/feature/function_02.png'"
                />
                <div>
                  ベルのマークを貼りつけてお届けすることができます。<br />
                  ご要望のお客様はご相談下さい。
                </div>
              </div>
            </div>

            <div style="position: relative;">
              <img
                class="product-image"
                v-lazy="'/static/products/eco-chime/feature/function_03.png'"
              />
              <div class="product-model">角型</div>
            </div>
            <div class="function">
              <div class="function-title">
                スタイリッシュなフォルムが魅力
              </div>
              <div class="function-detail">
                あらゆる場所や雰囲気に調和する、スタイリッシュなデザインが特長の角型。分かりやすいプッシュボタンが印象的なシリーズ。
              </div>
            </div>
            <div class="function">
              <div class="function-title">
                カラーバリエーション
              </div>
              <div class="function-detail">
                アイボリー (EC-301)、ブラック (EC-302)、パールレッド (EC-303)、
                パールブルー (EC-304)、ウッド (EC-305)
              </div>
            </div>
            <div
              class="function"
              style="border-bottom: 1px solid rgb(199, 199, 199);"
            >
              <div class="function-title">
                説明書き付きシールをお貼りできます
              </div>
              <div class="function-detail">
                <img
                  v-lazy="'/static/products/eco-chime/feature/function_04.png'"
                />
                <div>
                  説明書き付きシールを貼りつけてお届けすることができます。<br />
                  シール以外にもお店のロゴマークやイラストなどをお入れすることも可能です。ご要望のお客様はご相談下さい。
                </div>
              </div>
            </div>
          </div>

          <div class="product-block">
            <div class="product-block-header">
              <h3 class="product-genre">受信機</h3>
              <div class="product-detail">
                <p class="product-name">eco-chime 受信機</p>
                <p>自己発電した送信機からの</p>
                <p>電波をキャッチ！</p>
              </div>
            </div>
            <img
              class="product-image"
              v-lazy="'/static/products/eco-chime/feature/function_05.png'"
            />
            <div
              class="function"
              style="border-bottom: 1px solid rgb(199, 199, 199);"
            >
              <div class="function-title">
                □簡単設定 □安心の3年間保証<br />
                □最大50台の送信機と対応
                <span style="font-size: 11px;"
                  >※受信機(10窓タイプ)が5台必要です。
                </span>
              </div>
              <div class="function-detail">
                呼び出しに反応し、光で知らせてくれる受信機。対応する送信機の登録はとても簡単で誰でも設定が可能。<br />
                受信音は4種類で音量調整も可能。2回目の呼び出しには、点灯から点滅に変わり知らせてくれます。<br />
                1個のアダプターで最大5台の受信機に対応し、最大50個の送信機と対応できます。
              </div>
            </div>
            <div
              class="function"
              style="border-bottom: 1px solid rgb(199, 199, 199); margin-bottom: 100px;"
            >
              <div class="function-title">
                パトライト、外部スピーカーと連携（オプション）
              </div>
              <div class="function-detail">
                <div>
                  受信機(10窓タイプ)は<br />
                  パトライト、外部スピーカーに<br />
                  接続できます。
                </div>
                <img
                  v-lazy="'/static/products/eco-chime/feature/function_06.png'"
                />
              </div>
            </div>

            <div class="product-block-header">
              <div
                class="product-genre"
                style="padding: 15px 10px; vertical-align: middle;"
              >
                受信<br />表示機
              </div>
              <div class="product-detail">
                <p class="product-name">eco-chime 受信表示機</p>
                <p>大きな表示で</p>
                <p>呼び出しを見逃さない！</p>
              </div>
            </div>
            <img
              class="product-image"
              v-lazy="'/static/products/eco-chime/feature/function_07.png'"
            />
            <div
              class="function"
              style="border-bottom: 1px solid rgb(199, 199, 199);"
            >
              <div class="function-title">
                個室や広い店内・工場にはコレ!
              </div>
              <div class="function-detail">
                個室や離れなど目が届きにくい席や、騒音が大きい工場などでも安心して呼び出しに応えることができます。<br />
                また、少ないスタッフによるサービスの効率化や売り上げアップにもつなげます。
              </div>
            </div>
          </div>

          <div class="product-block">
            <div class="product-block-header">
              <h3 class="product-genre">中継機</h3>
              <div class="product-detail">
                <p class="product-name">eco-chime 中継機</p>
                <p>設定不要で、電源にさえ接続して</p>
                <p>いれば使用できます</p>
              </div>
            </div>
            <img
              class="product-image"
              v-lazy="'/static/products/eco-chime/feature/function_08.png'"
            />
            <div
              class="function"
              style="border-bottom: 1px solid rgb(199, 199, 199);"
            >
              <div class="function-title">
                □設定不要 □安心の3年間保証
              </div>
              <div class="function-detail">
                送信機や他の中継機からの電波信号を中継し、遠距離通信を可能にします。
              </div>
            </div>
          </div>

          <div class="product-block">
            <div class="product-block-header">
              <h3 class="product-genre">消去機</h3>
              <div class="product-detail">
                <p class="product-name">eco-chime 消去機</p>
                <p>受信表示機の表示を</p>
                <p>リセット！</p>
              </div>
            </div>
            <img
              class="product-image"
              v-lazy="'/static/products/eco-chime/feature/function_09.png'"
            />
            <div
              class="function"
              style="border-bottom: 1px solid rgb(199, 199, 199);"
            >
              <div class="function-title">
                送信機と同じく電池レスの消去機
              </div>
              <div class="function-detail">
                受信表示機の表示窓と同じ5つのボタンがあり、<br />
                それぞれ対応する表示窓の数字を消去します。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="feature-section">
      <div class="circle-parent">
        <div class="circle-heading blue">
          <h2 class="circle-heading-title">使用例</h2>
        </div>
      </div>
      <div class="header">
        <h3>
          離れた場所からの呼び出しに気づける
        </h3>
      </div>
      <img
        style="width: 100%;max-width: 850px;"
        src="/static/products/eco-chime/usage-example.png"
        alt="エコチャイム"
      />
      <p class="cta-microcopy" style="margin-top: 2.5rem">
        ＼この使い方にピンときた方へ／
      </p>
      <div
        class="column_wrap_cta"
        style="background: none; padding: 0; margin-bottom: 3.5rem"
      >
        <a class="column_wrap_cta_contact" href="/contact"
          >無料見積もり・お問い合わせはこちら</a
        >
      </div>
    </div>

    <div class="feature-section worry">
      <div class="circle-parent">
        <div class="circle-heading">
          <h2 class="circle-heading-title">お悩み<br />コンテンツ</h2>
        </div>
      </div>
    </div>
    <div class="worries-column" style="margin-bottom: 6%;">
      <div class="use-scene-block">
        <router-link to="/column/54">
          <div class="use-scene-block-header">
            「先生を呼びたいけど近くにいない」という悩みを解決する呼び出しベル
          </div>
        </router-link>
        <p>
          「先生を呼びたいけど近くにいない」と悩んでいる生徒を抱える学習塾や教育機関向けに、使いやすい呼び出しベルを紹介します。質問しやすい環境を作りたい方は、ぜひ参考にしてください。
        </p>
      </div>
      <div class="use-scene-block">
        <router-link to="/column/51">
          <div class="use-scene-block-header">
            レジでお客様を待たせてしまう悩みを解決する呼び出しベルとは
          </div>
        </router-link>
        <p>
          スタッフがレジから離れている際にお客様に気付かず、待たせてしまうという課題を抱えているなら、呼び出しベルの導入がおすすめです。レジ待ち解消に効果的な呼び出しベルについて詳しく紹介します。
        </p>
      </div>
      <div class="use-scene-block">
        <router-link to="/column/42">
          <div class="use-scene-block-header">
            お客様の呼び声に気付けないときにおすすめの呼び出しベルを紹介
          </div>
        </router-link>
        <p>
          この記事では、お客様の呼び出しに気付けない、見逃してしまう、といった状況に悩む飲食店のオーナーに向けて、最適な呼び出しベルの選び方と、おすすめの製品を紹介します。
        </p>
      </div>
      <div class="use-scene-block">
        <router-link to="/column/44">
          <div class="use-scene-block-header">
            人件費を削減したい飲食店に呼び出しベルの導入がおすすめな理由
          </div>
        </router-link>
        <p>
          この記事では人件費を削減したい飲食店向きに、呼び出しベルの導入がおすすめの理由や呼び出しベルの選び方、オペレーション効率化に向いた機種を紹介します。
        </p>
      </div>
    </div>

    <div class="feature-section" id="spec">
      <div class="circle-parent">
        <div class="circle-heading blue">
          <h2 class="circle-heading-title">仕様</h2>
        </div>
      </div>
      <div class="main-specification">
        <div class="specification-detail">
          <specs v-bind:useType="useType" v-bind:items="items" />
        </div>
      </div>
    </div>

    <div class="feature-section" id="price">
      <div class="circle-parent">
        <div class="circle-heading blue">
          <h2 class="circle-heading-title">価格</h2>
        </div>
      </div>
      <div class="main-specification">
        <div class="specification-detail">
          <prices
            v-bind:items="
              items.filter(function(item) {
                return (
                  (item.listPrice > 0 && item.regularPrice > 0) ||
                  item.openPrice > 0 ||
                  item.summaryImagePath
                )
              })
            "
          />
        </div>
      </div>
    </div>

    <div class="feature-section" id="catalogue">
      <div class="circle-parent">
        <div class="circle-heading blue">
          <h2 class="circle-heading-title">カタログ</h2>
        </div>
      </div>
      <div class="main-specification">
        <div class="specification-detail">
          <catalogues
            v-bind:useType="useType"
            v-bind:productName="productName"
            v-bind:items="catalogues"
          />
        </div>
      </div>
    </div>

    <div class="product_question">
      <h2 style="color: #0a518d">よくある質問</h2>
      <question-and-answer
        :number="1"
        :question="'送信機の電源は何ですか？'"
        :answer="
          `電磁誘導式自己発電部内蔵型の電池レス送信機ですので、電池のランニングコストがかからず交換の手間や電池によるトラブルがありません。`
        "
      />
      <question-and-answer
        :number="2"
        :question="'送信機の防水性や耐久性はどれくらいですか？'"
        :answer="
          `送信機のIP（防塵・防水）性能は、IP67に相当し、飲み物をこぼして汚れた時など、水洗いもOK！お風呂場で使用中に落下しても心配ありません。また、20万回のプッシュテストをクリアした高い耐久性があります。`
        "
      />
      <question-and-answer
        :number="3"
        :question="'商品の保証期間はいつまでですか？'"
        :answer="
          `販売後 3 年間の無償保証修理を行っております。それ以降でも有償となりますが、いつでも迅速に修理させていただきます。また、保証期間中はもちろん保証期間外でも修理期間中は貸出機をご提供するなどのサービスを行っています。`
        "
      />
    </div>

    <div class="column_nav">
      <h2 style="color: #0a518d">おすすめのコンテンツ</h2>
      <ul
        style="width: 100%; max-width: 960px; margin: 0 auto; box-sizing: border-box;"
      >
        <li>
          <a href="/choice/industry/5" target="_blank"
            ><img
              src="/static/columns/17/care_mv.png"
              alt="介護・福祉の呼出しベルについて"
          /></a>

          <h3>
            <a href="/choice/industry/5" target="_blank"
              >介護・福祉の呼出しベルについて</a
            >
          </h3>
        </li>
        <li>
          <a href="/column/3" target="_blank"
            ><img
              src="/static/columns/3/img_restaurant_waiting_time1.jpg"
              alt="【飲食店向け】待ち時間が発生する際のお客様への対応と時短アイデア"
          /></a>

          <h3>
            <a href="/column/3" target="_blank"
              >【飲食店向け】待ち時間が発生する際のお客様への対応と時短アイデア</a
            >
          </h3>
        </li>
        <li>
          <a href="/column/4" target="_blank"
            ><img
              src="/static/columns/4/img_increase_restaurant_turnover1.jpg"
              alt="飲食店の回転率を上げるべき理由は？用語の意味から改善策まで！"
          /></a>

          <h3>
            <a href="/column/4" target="_blank"
              >飲食店の回転率を上げるべき理由は？用語の意味から改善策まで！</a
            >
          </h3>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ProductFeatureSummary from '@/components/modules/ProductFeatureSummary'
import ContentHeader from '@/components/modules/ContentHeader'
import Specs from '@/components/modules/Specs'
import Prices from '@/components/modules/Prices'
import Catalogues from '@/components/modules/Catalogues'
import QuestionAndAnswer from '@/components/modules/QuestionAndAnswer'

export default {
  components: {
    ProductFeatureSummary,
    ContentHeader,
    Specs,
    Prices,
    Catalogues,
    QuestionAndAnswer,
  },
  data() {
    return {
      productName: 'eco-chime',
      useType: 2,
      items: [
        {
          name: '受信機',
          imagePath: '/static/products/eco-chime/items/item_01.png',
          spec: {
            型式: 'EC-110',
            サイズ: '120(W) × 194(D) × 22(H) mm',
            重量: '240g',
            電源: 'DC9V 1.3A',
            受信周波数: '314MHz',
            受信可能距離: '約 60m（見通し距離）',
            使用可能周囲温度: '-10℃～ 40℃',
            受信音: '4 種類',
            音量: '大・中・小・無音',
            保証: '3 年間',
          },
          priceName: `受信機 10 画面（EC-110)`,
          listPrice: 80000,
          regularPrice: 52000,
        },
        {
          name: '受信表示機',
          imagePath: '/static/products/eco-chime/items/item_02.png',
          spec: {
            型式: 'EC-100',
            サイズ: '600（W）×66.3（D）×119（H）mm',
            重量: '1,300g',
            電源: 'AC100～240V',
            受信周波数: '314MHz',
            受信可能距離: '約 100m（見通し距離）',
            使用可能周囲温度: '-10℃～ 40℃',
            受信音: '13 種類',
            音量: '大・中・小・無音',
            受信メモリー: '94 件',
            保証: '3 年間',
          },
          priceName: `受信表示機 LED 表示（EC-100)
          カラー：ブラック、アイボリー`,
          listPrice: 125000,
          regularPrice: 81250,
        },
        {
          name: '電池レス消去機',
          imagePath: '/static/products/eco-chime/items/item_03.png',
          spec: {
            型式: 'EC-400',
            サイズ: '67（W）×117（D）×26（H）mm',
            重量: '115g',
            電源: '電磁誘導式自己発電',
            受信周波数: '314MHz',
            消去: '表示機 5 窓に対応した 5 つのボタン',
            保証: '3 年間',
          },
          priceName: `電池レス消去機 5 窓対応
          （EC-400）`,
          listPrice: 15000,
          regularPrice: 9750,
        },
        {
          name: '中継機',
          imagePath: '/static/products/eco-chime/items/item_04.png',
          spec: {
            型式: 'EC-500',
            サイズ: '120（W）×194（D）×22（H）mm',
            重量: '240g',
            電源: 'DC9V 1.3A',
            受信周波数: '314MHz',
            受信可能距離: '約 60m（見通し距離）',
            使用可能周囲温度: '-10℃～ 40℃',
            保証: '3 年間',
          },
          priceName: `中継機 （EC-500）`,
          listPrice: 28000,
          regularPrice: 18200,
        },
        {
          name: '電池レス送信機角型',
          imagePath: '/static/products/eco-chime/items/item_05.png',
          spec: {
            型式: 'EC-300',
            サイズ: '68（W）×68（D）×22（H）mm',
            重量: '80g',
            電源: '電磁誘導式自己発電',
            カラー: `アイボリー（EC-301）
            ブラック（EC-302）
            パールレッド（EC-303）
            パールブルー（EC-304）
            ウッド（EC-305）`,
            送信周波数: '314MHz',
            保証: '3 年間',
          },
        },
        {
          name: '電池レス送信機角型',
          imagePath: '/static/products/eco-chime/items/item_07.png',
          priceName: `電池レス送信機 角型
          カラー：アイボリー（EC-301）、
          ブラック（EC-302）、
          パールレッド（EC-303）、
          パールブルー（EC-304）`,
          listPrice: 9000,
          regularPrice: 5850,
        },
        {
          name: '電池レス送信機角型',
          imagePath: '/static/products/eco-chime/items/item_08.png',
          priceName: `電池レス送信機 角型
          カラー：ウッド（EC-305）`,
          listPrice: 10000,
          regularPrice: 6500,
        },
        {
          name: '電池レス送信機丸型',
          imagePath: '/static/products/eco-chime/items/item_06.png',
          spec: {
            型式: 'EC-310',
            サイズ: '74（W）×74（D）×30（H）mm',
            重量: '65g',
            電源: '電磁誘導式自己発電',
            カラー: `ホワイト（EC-311）
            ブラック（EC-312）
            大理石調（EC-313）
            ライトウッド（EC-314）
            ウッド（EC-315）`,
            送信周波数: '314MHz',
            保証: '3 年間',
          },
        },
        {
          name: '電池レス送信機丸型',
          imagePath: '/static/products/eco-chime/items/item_09.png',
          priceName: `電池レス送信機 丸型
          カラー：ホワイト（EC-311）、
          ブラック（EC-312）`,
          listPrice: 9000,
          regularPrice: 5850,
        },
        {
          name: '電池レス送信機丸型',
          imagePath: '/static/products/eco-chime/items/item_10.png',
          priceName: `電池レス送信機 丸型
          カラー：大理石調（EC-313）、
          ライトウッド（EC-314）、
          ウッド（EC-315）`,
          listPrice: 10000,
          regularPrice: 6500,
        },
      ],
      catalogues: [
        {
          id: 1,
          name: 'エコチャイム',
          imagePath: '/static/products/eco-chime/catalogues/catalogue_01.jpg',
          downloadUri: '/static/products/eco-chime/catalogues/catalogue_01.pdf',
          pageCount: 4,
          fileType: 'PDF',
          fileSize: '約 1.6MB',
        },
        {
          id: 2,
          name: 'エコチャイム 取り扱い説明書',
          imagePath: '/static/products/eco-chime/catalogues/catalogue_02.jpg',
          downloadUri: '/static/products/eco-chime/catalogues/catalogue_02.pdf',
          pageCount: 8,
          fileType: 'PDF',
          fileSize: '約 1.5MB',
        },
      ],
    }
  },
}
</script>

<style scoped>
.feature-section .header h3 {
  color: rgb(16, 106, 203);
  font-size: 1.5em;
}

.feature-title-image {
  width: 100%;
  margin-top: 50px;
}

.sp-product .feature-title-image {
  width: 100%;
  height: auto;
  min-height: 30px;
  margin-top: 10px;

  object-fit: cover;
  object-position: 40% 100%;
}

.feature-contents {
  display: flex;
  justify-content: space-between;
}

.sp-product .feature-contents {
  flex-direction: column;
}

.feature-content {
  width: 30%;
  margin-top: 10px;
}

.sp-product .feature-content {
  width: 100%;
  margin-bottom: 0;
}

.feature-content img {
  position: static;

  width: 100%;
  height: auto;
}

.verification-test {
  background: linear-gradient(rgb(227, 235, 243), white);
}

.verification-test .body {
  display: flex;
  justify-content: space-between;

  width: 90%;
  max-width: 1100px;
  margin: 0 auto;

  text-align: left;
}

.sp-product .verification-test .body {
  flex-direction: column;
  justify-content: center;
}

.test-scene {
  width: 30%;
  margin-top: 10px;
}

.sp-product .test-scene {
  width: 100%;
}

.test-scene p {
  font-size: 12px;
  line-height: 20px;

  margin: 0;
}

.test-scene p a {
  font-weight: bold;

  text-decoration: none;

  color: rgb(16, 106, 203);
}

.test-scene h3 {
  margin-bottom: 10px;
}

.test-scene h4,
.use-scene-block h4 {
  margin-bottom: 10px;
  font-size: 1.17em;
}

.test-scene img {
  width: 100%;
  height: auto;
}

.use-scene {
  padding-bottom: 50px;

  background: rgb(228, 242, 254);
}

.use-scene .body {
  width: 90%;
  max-width: 1100px;
  margin: 0 auto;

  text-align: left;
}

.use-scene-block-headers {
  display: flex;
  justify-content: space-between;
}

.use-scene-block-header {
  font-size: 20px;
  font-weight: bold;

  padding-bottom: 10px;

  border-bottom: 1px solid rgb(16, 106, 203);
}

.use-scene-block-header + .use-scene-block-header {
  margin-left: 5%;
}

.use-scene-blocks {
  display: flex;
  justify-content: space-between;

  margin-top: 10px;
}

.use-scene-blocks .use-scene-block {
  width: 30%;
}

.use-scene-blocks .use-scene-block + .use-scene-block {
  margin-left: 5%;
}

.use-scene-blocks .use-scene-block img {
  width: auto;
  max-width: 100%;
  height: 40%;
  height: auto;
}

.product-block .product-name {
  color: rgb(16, 106, 203);
}

.product-block .product-model {
  font-size: 20px;
  font-weight: bold;

  position: absolute;
  bottom: -15px;

  display: inline-block;

  margin-bottom: 5px;
  padding: 0 25px;

  color: white;
  border-radius: 20px;
  background-color: rgb(16, 106, 203);
}

.feature-section .main-function .body .product-block .function {
  border-bottom: 0;
}

.feature-section
  .main-function
  .body
  .product-block
  .function
  .function-detail {
  display: flex;
  justify-content: space-between;

  vertical-align: middle;
}

.feature-section
  .main-function
  .body
  .product-block
  .function
  .function-detail
  img {
  width: 40%;
  height: 100%;
}
.feature-section
  .main-function
  .body
  .product-block
  .function
  .function-detail
  div {
  width: 55%;
  padding-top: 10px;
}

.worries-column .use-scene-block .use-scene-block-header {
  border-left: 4px solid rgb(16, 106, 203);
}

@media (max-width: 768px) {
  .link-button {
    font-size: 12px;
    font-weight: bold;
    line-height: 16px;
    float: right;
    min-width: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/products/features/EcoChime.vue